import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'pixl-table-loading-spinner',
  imports: [
    MatProgressSpinnerModule
  ],
  templateUrl: './table-loading-spinner.html',
  styleUrl: './table-loading-spinner.scss'
})
export class TableLoadingSpinnerComponent {
  name = input<string>('');
}
